import * as React from 'react'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { isAdmin, isManager, isProducer } from 'web-fns/dist/auth'

import DefaultButton from '../components/DefaultButton/DefaultButton'
import Switch from '../components/switch/switch'

import EnvironmentContext from '../../EnvironmentContext'
import { Brand as BrandType } from '../../../typings/types'

import BrandDetailsForm from './forms/BrandDetailsForm/BrandDetailsForm'
import BrandOrganizationStructureForm from './forms/BrandOrganizationStructureForm/BrandOrganizationStructureForm'
import BrandOtherDataForm from './forms/BrandOtherDataForm/BrandOtherDataForm'
import BrandSEODetailsForm from './forms/BrandSEODetailsForm/BrandSEODetailsForm'
import BrandSocialMediaForm from './forms/BrandSocialMediaForm/BrandSocialMediaForm'
import BrandConciergeForm from './forms/BrandConciergeForm/BrandConsiergeForm'
import { BrandSettinsHeader, AntdGlobalStyles, OrdersHeader } from './BrandDashboardSettings.style'

interface BrandDashboardSettingsWithDataProps {
  brandProfile?: BrandType
  brandOrderUuid?: string
  urlBrandId?: string
}
const BrandDashboardSettingsWithData: React.FC<BrandDashboardSettingsWithDataProps> = ({
  brandProfile,
  brandOrderUuid,
  urlBrandId,
}) => {
  const [showFirst, setShowFirst] = React.useState<boolean>(true)
  const [showSecond, setShowSecond] = React.useState<boolean>(false)

  React.useEffect(() => {
    document.getElementsByClassName('main-content')[0].classList.add('settings')
    document.body.className = ''
    document.body.classList.add('settings')

    return () => {
      document.getElementsByClassName('main-content')[0].classList.remove('settings')
      document.body.className = ''
      document.body.classList.add('settings')
    }
  }, [])
  const { GEN1_BASE_URL } = React.useContext(EnvironmentContext) || ''

  const flags = useFlags()
  const assetsButtonVisible = flags['brand-dashboard-assets-button']
  const deleteMergeButtonsFlag = flags['brand-dashboard-delete-merge-buttons']
  const enable2024NavigationBlack = flags['2024-navigation-black']
  const isAdminUser = isAdmin() || isProducer() || isManager()

  const brandSettingsHeader = (
    <BrandSettinsHeader>
      <Switch
        count={2}
        firstBtn="Details"
        secondBtn="SEO & Social"
        showFirst={showFirst}
        showFirstFn={setShowFirst}
        showSecond={showSecond}
        showSecondFn={setShowSecond}
      />
      {!enable2024NavigationBlack && (
        <div>
          {assetsButtonVisible && (
            <DefaultButton
              fontSize="0.875rem"
              padding="0 1rem"
              backgroundColor="white"
              borderColor={colors.black1}
              color={colors.black1}
              buttonHeight="2.75rem"
              rounded
              hoverBackground={colors.black1}
              hoverColor="white"
              style={{ borderWidth: '2px' }}
              onClick={() => {
                window.open(`${GEN1_BASE_URL}/organisations/${urlBrandId}/brand_assets`, '_blank')
              }}
            >
              Manage brand assets
            </DefaultButton>
          )}
          {isAdminUser && (
            <DefaultButton
              fontSize="0.875rem"
              padding="0 1.25rem"
              backgroundColor={colors.adaptBlue}
              buttonHeight="2.75rem"
              rounded
              hoverBackground={colors.adaptBlue}
              hoverColor="white"
              style={{ borderWidth: '2px' }}
              onClick={() => {
                window.open(
                  `${GEN1_BASE_URL}/organisations/${urlBrandId}/account_products`,
                  '_blank'
                )
              }}
            >
              Brand management
            </DefaultButton>
          )}
        </div>
      )}
    </BrandSettinsHeader>
  )

  return (
    <>
      <AntdGlobalStyles />
      <OrdersHeader>
        <h3 data-testid="header-title">Settings</h3>
      </OrdersHeader>
      {brandSettingsHeader}
      {showFirst ? (
        <>
          <BrandDetailsForm brandProfile={brandProfile} brandOrderUuid={brandOrderUuid} />
          <BrandOrganizationStructureForm
            brandProfile={brandProfile}
            brandOrderUuid={brandOrderUuid}
          />
          <BrandOtherDataForm brandProfile={brandProfile} brandOrderUuid={brandOrderUuid} />
          {deleteMergeButtonsFlag && (
            <BrandConciergeForm brandProfile={brandProfile} brandOrderUuid={brandOrderUuid} />
          )}
        </>
      ) : (
        <>
          <BrandSEODetailsForm brandProfile={brandProfile} brandOrderUuid={brandOrderUuid} />
          <BrandSocialMediaForm brandProfile={brandProfile} brandOrderUuid={brandOrderUuid} />
        </>
      )}
    </>
  )
}

export default BrandDashboardSettingsWithData



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/BrandDashboardSettings/BrandDashboardSettingsWithData.tsx